import PropTypes from 'prop-types'
import React, { Component } from 'react'
import {
  Container,
  Icon,
  Grid,
  List,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility,
  Header,
} from 'semantic-ui-react'
import { NavLink } from "react-router-dom";

import {FormattedMessage} from 'react-intl';

import Logo from './Logo';


const Footer = () => (
      <Segment inverted vertical style={{ padding: '5em 3em' }}>
        <Grid divided inverted stackable>
          <Grid.Row>
            <Grid.Column width={3}>
              <Header inverted as='h4'>
                <FormattedMessage id="audory.responsiveContainer.header.aboutUs" />
              </Header>
              <List link inverted>
                <List.Item as={NavLink} to='/team' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.team" /></List.Item>
                <List.Item as={NavLink} to='/career' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.career" /></List.Item>
                <List.Item as={NavLink} to='/press' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.press" /></List.Item>
                
              </List>
            </Grid.Column>
            <Grid.Column width={3}>
              <Header inverted as='h4'>
                <FormattedMessage id="audory.responsiveContainer.header.services" />
              </Header>
              <List link inverted>
                {/*<List.Item as={NavLink} to='/books' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.audiobooks" /></List.Item>*/}
                <List.Item as={NavLink} to='/gutschein' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.gutschein" /></List.Item>
                <List.Item as={NavLink} to='/editor' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.editor" /></List.Item>
                <List.Item as={NavLink} to='/b2b' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.b2b" /></List.Item>
                <List.Item as={NavLink} to='/faq' exact onClick={()=>{window.scrollTo(0,0)}}><FormattedMessage id="audory.responsiveContainer.body.faq" /></List.Item>
              </List>
            </Grid.Column>
            <Grid.Column width={3}>
              <Header inverted as='h4'>
                <FormattedMessage id="audory.responsiveContainer.header.social" />
              </Header>
              <List link inverted>
                <List.Item href='https://www.instagram.com/audory_official/' target='_blank'>
                  <Icon name='instagram' style={{display: 'inline'}} />
                  <FormattedMessage id="audory.responsiveContainer.body.instagram" />
                </List.Item>
                {
                  /*
                <List.Item href='https://www.facebook.com/playaudory' target='_blank'>
                  <Icon name='facebook' style={{display: 'inline'}} />
                  <FormattedMessage id="audory.responsiveContainer.body.facebook" />
                </List.Item>
                <List.Item href='https://www.facebook.com/groups/audory.autoren/' target='_blank'>
                  <Icon name='facebook' style={{display: 'inline'}} />
                  <FormattedMessage id="audory.responsiveContainer.body.fbAuthors" />
                </List.Item>
                <List.Item href='https://www.facebook.com/groups/audory.hoerer/' target='_blank'>
                  <Icon name='facebook' style={{display: 'inline'}} />
                  <FormattedMessage id="audory.responsiveContainer.body.fbListeners" />
                </List.Item>
                  */
                }
                
              </List>
            </Grid.Column>
            <Grid.Column width={4}>
              <List link inverted>
                <List.Item as={NavLink} to='/tos' exact target='_blank'><FormattedMessage id="audory.responsiveContainer.body.termsOfUse" /></List.Item>
                <List.Item as={NavLink} to='/imprint' exact target='_blank'><FormattedMessage id="audory.responsiveContainer.body.imprint" /></List.Item>
                <List.Item as={NavLink} to='/privacypolicy' exact target='_blank'><FormattedMessage id="audory.responsiveContainer.body.privacypolicy" /></List.Item>
              </List>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Container style={{textAlign: 'center', marginTop: "5em"}}>
        <p>Made with <Icon name='heart' color='green' /> in Chemnitz</p>
        </Container>
        
      </Segment>
);

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
    state = {}
  
    hideFixedMenu = () => this.setState({ fixed: false })
    showFixedMenu = () => this.setState({ fixed: true })
  
    render() {
      const { children } = this.props;
      const { fixed } = this.state;

      return (
        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <Visibility
            once={false}
            onBottomPassed={this.showFixedMenu}
            onBottomPassedReverse={this.hideFixedMenu}
          >
            <Segment
              inverted
              textAlign='center'
              style={{ padding: '1em 0em' }}
              vertical
            >
              <Menu
                fixed={fixed ? 'top' : null}
                inverted
                pointing={!fixed}
                secondary={!fixed}
                style={{ borderWidth: 0, borderBottom: !fixed ? 'none' : '1px solid white'}}
                size='large'
              >
                <Container>
                  <Container style={{textAlign: 'left', padding: '0.5em'}}>
                    <Container as={NavLink} to='/' onClick={()=>{window.scrollTo(0,0)}}  style={{width: 150, float: 'left'}}>
                      <Logo style={{width: 150}} inverted />
                    </Container>
                  </Container>
                  <Menu.Item position='right' as={NavLink} to='/' onClick={()=>{window.scrollTo(0,0)}} exact>
                    <FormattedMessage id="audory.responsiveContainer.head.home" />
                  </Menu.Item>
                  {/*<Menu.Item as={NavLink} to='/books' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.audiobooks" /></Menu.Item>*/}
                  <Menu.Item as={NavLink} to='/gutschein' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.gutschein" /></Menu.Item>
                  <Menu.Item as={NavLink} to='/editor' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.editor" /></Menu.Item>
                  {/*<Menu.Item as={NavLink} to='/funding' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.funding" /></Menu.Item>*/}
                  <Menu.Item as={NavLink} to='/team' onClick={()=>{window.scrollTo(0,0)}} exact><FormattedMessage id="audory.responsiveContainer.body.team" /></Menu.Item>
                  {
                    /*
                    <Menu.Item position='right'>
                      <Button as='a' inverted={!fixed}>
                        Log in
                      </Button>
                      <Button as='a' inverted={!fixed} primary={fixed} style={{ marginLeft: '0.5em' }}>
                        Sign Up
                      </Button>
                    </Menu.Item>
                    */
                  }
                </Container>
              </Menu>
            </Segment>
          </Visibility>

          {children}

          <Footer />
          
        </Responsive>
      )
    }
  }
  
  DesktopContainer.propTypes = {
    children: PropTypes.node,
  }
  
  class MobileContainer extends Component {
    state = {}
  
    handlePusherClick = () => {
      const { sidebarOpened } = this.state
  
      if (sidebarOpened) this.setState({ sidebarOpened: false })
    }
  
    handleToggle = () => this.setState({ sidebarOpened: !this.state.sidebarOpened })
  
    render() {
      const { children } = this.props;
      const { sidebarOpened } = this.state;
  
      return (
        <Responsive maxWidth={Responsive.onlyMobile.maxWidth}>
          <Sidebar.Pushable>
            <Sidebar as={Menu} animation='uncover' inverted vertical visible={sidebarOpened}>
            <Menu.Item>
              <Container>
                  <Container as={NavLink} to='/' onClick={this.handleToggle} style={{textAlign: 'center'}}>
                    <Logo style={{width: 150}} inverted />
                  </Container>
              </Container>
            </Menu.Item>
            <Menu.Item as={NavLink} to='/' exact onClick={this.handleToggle}>
              <FormattedMessage id="audory.responsiveContainer.head.home" />
            </Menu.Item>
            {/*<List.Item as={NavLink} to='/books' onClick={this.handleToggle} exact><FormattedMessage id="audory.responsiveContainer.body.audiobooks" /></List.Item>*/}
            <Menu.Item as={NavLink} to='/gutschein' exact onClick={this.handleToggle}><FormattedMessage id="audory.responsiveContainer.body.gutschein" /></Menu.Item>
            <Menu.Item as={NavLink} to='/editor' exact onClick={this.handleToggle}><FormattedMessage id="audory.responsiveContainer.body.editor" /></Menu.Item>
            {/*<Menu.Item as={NavLink} to='/funding' exact onClick={this.handleToggle}><FormattedMessage id="audory.responsiveContainer.body.funding" /></Menu.Item>*/}
            <Menu.Item as={NavLink} to='/team' exact onClick={this.handleToggle}><FormattedMessage id="audory.responsiveContainer.body.team" /></Menu.Item>
            {
              /*
                <Menu.Item as='a'>Log in</Menu.Item>
                <Menu.Item as='a'>Sign Up</Menu.Item>
              */
            }
            </Sidebar>
  
            <Sidebar.Pusher
              dimmed={sidebarOpened}
              onClick={this.handlePusherClick}
              style={{ minHeight: '100vh' }}
            >
              <Segment
                inverted
                textAlign='center'
                style={{ padding: '1em 0em' }}
                vertical
              >
                <Container>
                  <Menu inverted pointing secondary size='large' style={{borderWidth: 0}}>
                    <Menu.Item onClick={this.handleToggle}>
                      <Icon name='sidebar' />
                    </Menu.Item>
                  {
                    /*
                      
                        <Menu.Item position='right'>
                          <Button as='a' inverted>
                            Log in
                          </Button>
                          <Button as='a' inverted style={{ marginLeft: '0.5em' }}>
                            Sign Up
                          </Button>
                        </Menu.Item>
                      
                    */
                  }
                  </Menu>
                </Container>
              </Segment>
  
              {children}

              <Footer />
              
            </Sidebar.Pusher>
          </Sidebar.Pushable>
        </Responsive>
      )
    }
  }
  
  MobileContainer.propTypes = {
    children: PropTypes.node,
  }

  /* eslint-disable react/no-multi-comp */
/* Heads up! HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled components for
 * such things.
 */


  class ResponsiveContainer extends Component{
    render(){
      return(
        <React.Fragment>
          <DesktopContainer>{this.props.children}</DesktopContainer>
          <MobileContainer>{this.props.children}</MobileContainer>
        </React.Fragment>
      );
    }
  }
  
  ResponsiveContainer.propTypes = {
    children: PropTypes.node,
  }

  export default ResponsiveContainer;



// WEBPACK FOOTER //
// ./src/components/ResponsiveContainer.js